/* eslint-disable react/no-array-index-key */
import { Container, Row, Col } from 'react-bootstrap';
import CardWithHeaderImage from '../../../Components/Card/cardWithHeaderImage/CardWithHeaderImage';
import cardImage1 from '../../../assets/images/png/beauty_reads1.png';
import cardImage2 from '../../../assets/images/png/beauty_reads2.png';
import cardImage3 from '../../../assets/images/png/beauty_reads3.png';
import cardImage4 from '../../../assets/images/png/diettypes.png';
import { SectionHeadingMed } from '../../../Components/Headings';
import './cookingMealPrep.css';

function CookingMealPrep() {
  const cardDatas = [
    {
      image: cardImage1,
      topic: 'What Are the Top 12 Benefits of Swimming?',
      desc: '',
      btnText: 'read more'
    },
    {
      image: cardImage2,
      topic: 'Benefits of Starting Your Day with a Walk',
      desc: '',
      btnText: 'read more'
    },
    {
      image: cardImage3,
      topic: 'People Who Exercise in Groups Get More Health Benefits',
      desc: '',
      btnText: 'read more'
    },
    {
      image: cardImage4,
      topic: '14 Benefits of Strength Training',
      desc: '',
      btnText: 'read more'
    }
  ];

  return (
    <section className="cookingMealPrep">
      <Container>
        <SectionHeadingMed text="COOKING AND MEAL PREP" />
        <Row>
          {cardDatas.map((cardData, index) => (
            <Col md={3} key={index}>
              <CardWithHeaderImage {...cardData} />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default CookingMealPrep;
